import { render, staticRenderFns } from "./EditAmount.vue?vue&type=template&id=b8559a06&scoped=true&"
import script from "./EditAmount.vue?vue&type=script&lang=js&"
export * from "./EditAmount.vue?vue&type=script&lang=js&"
import style0 from "./EditAmount.vue?vue&type=style&index=0&id=b8559a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8559a06",
  null
  
)

export default component.exports